import './PermissionsPage.css'
import React, { useEffect } from "react";
import Header from '../../components/common/Header/Header';
import { AppDispatch } from '../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import PermissionsContainer from './components/PermissionsContainer';
import { fetchPermissions } from '../../redux/actions/permissions.actions';
import RootState from '../../redux/states/root.state';
import { ShieldCheckIcon } from '../../components/common/Icons/Icons';

const PermissionsPage = () => {
  const dispatch: AppDispatch = useDispatch();
  const searchParams = useSearchParams()[0];
  const {meta} = useSelector((state: RootState) => state.permissions);

  // Dispatch UseEffects
  useEffect(() => {
    dispatch(fetchPermissions(searchParams.toString()));
  }, [dispatch, searchParams]);

  return (
    <div className="page lp-page">
      <Header
        header="Permissions"
        headerExtra={meta?.total !== undefined &&
          <ul className="lp-stats" aria-label="Summary">
            <li className="lp-stat"><ShieldCheckIcon/><b>{(meta?.total ?? 0).toLocaleString()}</b> Permissions</li>
          </ul>
        }
      />
      <main className="lp-main">
        <PermissionsContainer/>
      </main>
    </div>
  );
};

export default PermissionsPage;
